<template>
  <div class="no-data">
    <img src="@/assets/no-data.png" alt="">
    <div>{{ msg }}</div>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      type: String,
      default: '暂无数据'
    }
  },

  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>
<style lang="scss">
.no-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 5.32rem;
  height: 4.65rem;

  img {
    width: 100%;
  }

  div {
    height: 0.34rem;
    font-size: 0.34rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5893F0;
    line-height: 0.38rem;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NoData/index.vue